/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Subjectplaceholder3Inputs */

const en_coinvestments_editemail_subjectplaceholder3 = /** @type {(inputs: Coinvestments_Editemail_Subjectplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter email subject...`)
};

/**
* | output |
* | --- |
* | "Enter email subject..." |
*
* @param {Coinvestments_Editemail_Subjectplaceholder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_subjectplaceholder3 = /** @type {((inputs?: Coinvestments_Editemail_Subjectplaceholder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Subjectplaceholder3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_subjectplaceholder3(inputs)
});
export { coinvestments_editemail_subjectplaceholder3 as "coInvestments_editEmail_subjectPlaceholder" }